import LoginLayout from "./loginLayout";

export default LoginLayout;